export default __webpack_public_path__ + "static/garden_design17-45eff0651e3fc71a7d7918051f3a3b8c.webp";